export default __webpack_public_path__ + "static/media/declarations.0649467b.svg";